import { HomeApplication } from '@/reactPages/Home/Application';
import NextWrapper from '@/components/layouts/Containers/NextWrapper/NextWrapper';

const meta = {
  title: 'Заявка на улучшение жилищных условий: Подать заявку',
  description:
    'Подайте заявку на улучшение ваших жилищных условий. Заполните анкету и мы с вами свяжемся ',
  keywords:
    'Заявка, Улучшение жилищных условий, Анкета, заполнить анкету,  подать заявку, подам заявку',
};

const Home = () => {
  return (
    <>
      <NextWrapper meta={meta}></NextWrapper>
      <HomeApplication></HomeApplication>
    </>
  );
};

export default Home;
